/**
 * Shared legend utility functions
 */

import { IntervalItem, IntervalWithValueItem, Unit } from '@ais-ui/websockets';

export const getIntervalText = (
  item: IntervalWithValueItem | IntervalItem,
): string | number => {
  if (item.start_interval !== item.end_interval) {
    return `${item.start_interval} - ${item.end_interval}`;
  }
  return item.start_interval;
};

export const unitToText = (unit: Unit): string => {
  switch (unit) {
    case 'count':
      return 'Count';
    case 'km/h':
      return 'Km/h';
    case 'degreesCelsius':
      return '°C';
    case 'percentage':
      return '%';
    case 'knots':
      return 'Knots';
    case 'meters':
      return 'Meters';
    case 'degrees':
      return '°';
    case 'm3':
      return 'm³';
    default:
      return '';
  }
};

export const getValueText = (item: IntervalWithValueItem): string => {
  return parseFloat(item.value).toFixed(2);
};
